import { a, getSelectedShapes, getMode, getDisplayedShapes } from "../../shared/globalState/a";
import { t as _t } from "../../shared/globalState/t";
import { canvasGetMouse } from "../../shared/common";
import { g } from "../../shared/globalState/g";

import { Point as _Point } from "../../models/Point";

import { drawShapes as _drawShapes, addShapes, updateActiveShapes as _updateActiveShapes, updateAndDrawShapes } from "../../shared/render/shapes";

import { selectedText$, textLinesCollection } from "../../libs/canvas-text/src/shared/state";

// --- rxjs
import { fromEvent as _fromEvent, map as _map } from "rxjs";
import { cnv } from "../../libs/canvas-text/src/shared/cnv";
import { rerender } from "../../libs/canvas-text/src";
import { handleSpacebarUp } from "../keyboard/spacebar";
import { ObjectTypes } from "../../shared/enums";

import { ElbowBlock } from "../../models/resistances/ElbowBlock";
import { checkConnections } from "../../services/operations";
import { Block } from "../../models/shapes/Block";


function handleMouseUp(event) {
    // console.log('shapes', a.shapes.length);

    if (event.button === 1 || event.button === 4) {
        handleSpacebarUp();
        return;
    }



    var mouse = canvasGetMouse(event, g.canvas);

    if (a.blockUI) return;

    a.isMouseDown = false;

    if (a.magnetPosition) {
        a.end = { ...a.magnetPosition };
    }
    else if (a.anglePosition) {
        a.end = { ...a.anglePosition };
    }
    else {
        a.end = mouse;
    }


    switch (getMode()) {
        case 'edit': {
            const editShapes = a.shapes.filter(shape => shape.edit !== null);
            if (editShapes.length > 0) {
                editShapes.forEach(shape => {
                    switch (shape.type) {
                        case ObjectTypes.line:
                            if (shape.edit === 'start') {
                                shape.start = a.end;
                            }
                            else if (shape.edit === 'end') {
                                shape.end = a.end;
                            }
                            break;
                        case ObjectTypes.rectangle:
                            if (a.ctrl) {
                                if (['p1', 'p2', 'p3', 'p4'].includes(shape.edit)) {

                                    const dx = a.end.x - shape.center.x;
                                    const dy = a.end.y - shape.center.y;

                                    shape.p1.x = shape.center.x - dx;
                                    shape.p1.y = shape.center.y - dy;

                                    shape.p2.x = shape.center.x + dx;
                                    shape.p2.y = shape.center.y - dy;

                                    shape.p3.x = shape.center.x + dx;
                                    shape.p3.y = shape.center.y + dy;

                                    shape.p4.x = shape.center.x - dx;
                                    shape.p4.y = shape.center.y + dy;

                                    shape.updateMid();
                                    shape.updateCenter();
                                    shape.updatePoints();
                                    shape.setSelectBoundary();

                                }
                            }
                            else {
                                if (shape.edit === 'p1') {
                                    shape.p1 = a.end;
                                    shape.p4.x = a.end.x;
                                    shape.p2.y = a.end.y;
                                }
                                else if (shape.edit === 'p2') {
                                    shape.p2 = a.end;
                                    shape.p3.x = a.end.x;
                                    shape.p1.y = a.end.y;
                                }
                                else if (shape.edit === 'p3') {
                                    shape.p3 = a.end;
                                    shape.p2.x = a.end.x;
                                    shape.p4.y = a.end.y;
                                }
                                else if (shape.edit === 'p4') {
                                    shape.p4 = a.end;
                                    shape.p1.x = a.end.x;
                                    shape.p3.y = a.end.y;
                                }
                                shape.updateMid();
                                shape.updateCenter();
                                shape.updatePoints();
                                shape.setSelectBoundary();
                            }
                            break;
                        default:
                            break;
                    }
                })
            }

            break;
        }
        case 'select':

            if (a.selectFrame.skew > 0) {
                if (getSelectedShapes().some(s => s.isinSelectFrame(a.selectFrame))) {
                    getSelectedShapes().filter(s => s.isinSelectFrame(a.selectFrame)).forEach(s => {
                        s.isSelected = false;
                    })
                }

                else {
                    a.activeShapes.forEach(shape => {
                        if (shape.isinSelectFrame(a.selectFrame)) {
                            shape.isSelected = true;
                        }
                    });
                }
            }
            else {
                a.activeShapes.forEach(shape => {
                    if (shape.iscrossSelectFrame(a.selectFrame)) {
                        shape.isSelected = true;
                    }
                })
            }

            // --- text
            // a.selectFrame.convertToCanvas2d(cnv.context.canvas.width, cnv.context.canvas.height);
            textLinesCollection.forEach(text => {
                if (text.isinSelectFrame(a.selectFrame)) {
                    text.selected = !text.selected;
                }
            });

            cnv.clear();
            rerender();
            // --- text



            break;
        case ObjectTypes.line:
            break;
        case 'symline':
            a.symline.end = a.end;
            a.line.start = a.symline.end;
            a.line.end = a.symline.symend;
            addShapes(a.line.getClone());
            break;
        case ObjectTypes.rectangle:
            break;
        case 'square':
            break;
        case ObjectTypes.circle:
            break;
        default:
            break;
    }

    // ********* select observer *********
    /**
     * При каждом событии mouseup будет проверяться массив фигур на наличие фигур isSelected
     */
    a.selected$.next(getSelectedShapes());
    // --- text
    selectedText$.next(textLinesCollection.filter(t => t.selected));
    // --- text


    // reset all edits
    a.shapes.filter(shape => shape.edit !== null).forEach(shape => shape.edit = null);



    closeBlockConnectors();

    updateAndDrawShapes();


}


export { handleMouseUp }

/**
 * Функция проверяет точки присоединения блоков и "закрывает" их, если
 * блок соединён.
 */
function closeBlockConnectors() {
    
    let elbows = getDisplayedShapes().filter(s => (s instanceof ElbowBlock) || (s instanceof Block));
    elbows.forEach(elbow => {

        checkConnections(elbow, getDisplayedShapes());
    });
}

